<template>
<div>
  <com-header className="lecto-header-contain" :compID="$route.params.id" activeKey="flxx"></com-header>
  <iframe
    :src="`${LectoWeb}/full/company/${$route.params.id}?source=engineer_client`"
    id="lectoIframe"
    frameborder="0"
    :style="{ height: '100vh' }"
  ></iframe>
</div>
</template>

<script>
// https://smart3d.maidiyun.com:3006/full/company/${$route.params.id}?source=engineer_client
import ComHeader from '/@/views/company/header/index.vue';
import {OpenService} from '@/service';
import {DomainService} from '@/libs'

export default {
  data() {
    return {
      LectoWeb: DomainService.LectoWeb,
    }
  },
  components: { ComHeader },
  mounted() {
    window.iframeMessage = this.iframeMessage;
    window.removeEventListener('message', window.iframeMessage, false);
    window.addEventListener('message', window.iframeMessage, false);
  },
  beforeDestroy() {
    window.removeEventListener('message', this.iframeMessage, false);
  },
  methods: {
    iframeMessage(e) {
      const data = e.data || {};
      const value = data.data || 0;
      if (data.key === "scroll_top") {
        const headerDom = document.querySelector('.header-contain');
        if (headerDom) {
          headerDom.style.transform = `translateY(-${value >= 146 ? 146 : value}px)`
        }
      }
      if (data.key === "lecto_detail") {
        OpenService.openProdDetails(value.prodID, value.lecto_params || '');
      }
      if (data.key === "engineer_lecto_header_click") {
        OpenService.openCompDetail(this.$route.params.id);
      }
    }
  }
}
</script>

<style lang="less" scoped>
iframe{
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
}
.lecto-header-contain{
  pointer-events: none;
  /deep/ .call-btn,/deep/ .el-tabs__header,/deep/ .el-input-group{
    pointer-events: all;
  }
}
</style>
